import React from 'react';
import { Search, User } from 'lucide-react';

const EmployeeSearchPanel = ({
  employees,
  selectedEmployee,
  searchTerm,
  onSearchChange,
  onEmployeeSelect,
  loading
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Select Employee</h3>

      {/* Search */}
      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search employees..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
        />
      </div>

      {/* Employee List */}
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600 mx-auto"></div>
          </div>
        ) : employees?.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <User className="w-12 h-12 mx-auto mb-2 text-gray-300" />
            <p className="text-sm">No employees found</p>
          </div>
        ) : (
          employees?.map(employee => (
            <button
              key={employee?.id}
              onClick={() => onEmployeeSelect(employee)}
              className={`w-full text-left p-3 rounded-lg border transition-all ${
                selectedEmployee?.id === employee?.id
                  ? 'bg-emerald-50 border-emerald-500 ring-2 ring-emerald-200' :'bg-white border-gray-200 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <User className="w-5 h-5 text-gray-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm text-gray-900 truncate">
                    {employee?.firstName} {employee?.lastName}
                  </p>
                  <p className="text-xs text-gray-600 truncate">
                    {employee?.employeeNumber} • {employee?.department}
                  </p>
                </div>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default EmployeeSearchPanel;